var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EntryTableEditor"},[(_vm.entryIds)?_c('div',{staticStyle:{"overflow-x":"auto"}},[_c('table',_vm._l((_vm.entryIds),function(entryId){return _c('EntryTableEditorRow',{key:entryId,attrs:{"entryId":entryId},on:{"subedit":_vm.forwardSubedit,"subeditAsset":_vm.forwardSubeditAsset}})}),1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }